import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

export default function Profileinformation() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    gender: "",
    dob: "",
    age: "",
    religion: "",
    caste: "",
    district: "",
    taluk: "",
    email: "",
    jobType: "",
    qualification: "",
    hobbies: "",
    fatherName: "",
    motherName: "",
    brotherName: "",
    sisterName: ""
  });

  const [mainImage, setMainImage] = useState("images/default-profile.jpg");
  const [allImages, setAllImages] = useState([]);

  useEffect(() => {
    try {
      const saved = sessionStorage.getItem("userDetails");
      if (saved) setFormData((prev) => ({ ...prev, ...JSON.parse(saved) }));

      const storedImages = JSON.parse(sessionStorage.getItem("profileImages") || "[]");
      if (storedImages.length > 0) {
        setAllImages(storedImages);
        setMainImage(storedImages[0]);
      }
    } catch (err) {
      console.error("Error loading session data:", err);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      const payload = {
        ...formData,
        mainImage,
        profileImages: allImages
      };

      // Save locally also
      sessionStorage.setItem("userDetails", JSON.stringify(formData));
      sessionStorage.setItem("profileImages", JSON.stringify(allImages));
      sessionStorage.setItem("mainImage", JSON.stringify(mainImage));

      // ✅ Send to backend
      const response = await axios.post("http://localhost:4000/api/profile", payload);

       // Show full response in console
            console.log("✅ Backend Response:", response.data);
      

      if (response.status === 200) {
        alert("Profile details sent to backend ✅");
      } else {
        alert("Failed to save profile ❌");
      }
    } catch (error) {
      console.error("Error saving profile:", error);
      alert("Error while saving profile ❌");
    }
  };

  return (
    <div>
          {/* <!-- PRELOADER --> */}
    {/* <div id="preloader">
        <div className="plod">
            <span className="lod1"><img src="images/loder/1.png" alt="" loading="lazy"/></span>
            <span className="lod2"><img src="images/loder/2.png" alt="" loading="lazy"/></span>
            <span className="lod3"><img src="images/loder/3.png" alt="" loading="lazy"/></span>
        </div>
    </div>
    <div className="pop-bg"></div> */}
    {/* <!-- END PRELOADER --> */}

    {/* <!-- SEARCH --> */}
    <div className="pop-search">
        <span className="ser-clo">+</span>
        <div className="inn">
            <form>
                <input type="text" placeholder="Search here..."/>
            </form>
            <div className="rel-sear">
                <h4>Top searches:</h4>
                <a href="all-profiles.html">Browse all profiles</a>
                <a href="all-profiles.html">Mens profile</a>
                <a href="all-profiles.html">Female profile</a>
                <a href="all-profiles.html">New profiles</a>
            </div>
        </div>
    </div>
    {/* <!-- END PRELOADER --> */}

    {/* <!-- HEADER & MENU --> */}
    <div className="head-top">
        <div className="container">
            <div className="row">
                <div className="lhs">
                    <ul>
                        <li><a href="#!" className="ser-open"><i className="fa fa-search" aria-hidden="true"></i></a></li>
                        <li><a href="about.html">About</a></li>
                        <li><a href="faq.html">FAQ</a></li>
                        <li><a href="contact.html">Contact</a></li>
                    </ul>
                </div>
                <div className="rhs">
                    <ul>
                        <li><a href="tel:+9704462944"><i className="fa fa-phone" aria-hidden="true"></i>&nbsp;+01 5312
                                5312</a></li>
                        <li><a href="mailto:info@example.com"><i className="fa fa-envelope-o"
                                    aria-hidden="true"></i>&nbsp; help@company.com</a></li>
                        <li><a href="#!"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                        <li><a href="#!"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                        <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- END HEADER & MENU --> */}

    {/* <!-- HEADER & MENU --> */}
    <div className="menu-pop menu-pop1">
        <span className="menu-pop-clo"><i className="fa fa-times" aria-hidden="true"></i></span>
        <div className="inn">
            <img src="images/logo-b.png" alt="" loading="lazy" className="logo-brand-only"/>
            <p><strong>Best Wedding Matrimony</strong> lacinia viverra lectus. Fusce imperdiet ullamcorper metus eu
                fringilla.Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
            <ul className="menu-pop-info">
                <li><a href="#!"><i className="fa fa-phone" aria-hidden="true"></i>+92 (8800) 68 - 8960</a></li>
                <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i>+92 (8800) 68 - 8960</a></li>
                <li><a href="#!"><i className="fa fa-envelope-o" aria-hidden="true"></i>help@company.com</a></li>
                <li><a href="#!"><i className="fa fa-map-marker" aria-hidden="true"></i>3812 Lena Lane City Jackson Mississippi</a></li>
            </ul>
            <div className="menu-pop-help">
                <h4>Support Team</h4>
                <div className="user-pro">
                    <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                </div>
                <div className="user-bio">
                    <h5>Ashley emyy</h5>
                    <span>Senior personal advisor</span>
                    <a href="enquiry.html" className="btn btn-primary btn-sm">Ask your doubts</a>
                </div>
            </div>
            <div className="menu-pop-soci">
                <ul>
                    <li><a href="#!"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-instagram" aria-hidden="true"></i></a></li>
                </ul>
            </div>
        </div>
    </div>
    {/* <!-- END HEADER & MENU --> */}

    {/* <!-- HEADER & MENU --> */}
    <div className="menu-pop menu-pop2">
        <span className="menu-pop-clo"><i className="fa fa-times" aria-hidden="true"></i></span>
        <div className="inn">
            <div className="menu-pop-help">
                <h4>Support Team</h4>
                <div className="user-pro">
                    <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                </div>
                <div className="user-bio">
                    <h5>Ashley emyy</h5>
                    <span>Senior personal advisor</span>
                    <a href="enquiry.html" className="btn btn-primary btn-sm">Ask your doubts</a>
                </div>
            </div>
            <div className="menu-pop-soci">
                <ul>
                    <li><a href="#!"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-instagram" aria-hidden="true"></i></a></li>
                </ul>
            </div>

            <div className="late-news">
                <h4>Latest news</h4>
                <ul>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/1.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/3.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/4.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                </ul>
            </div>

            {/* <!-- HELP BOX --> */}
            <div className="prof-rhs-help">
                <div className="inn">
                    <h3>Tell us your Needs</h3>
                    <p>Tell us what kind of service you are looking for.</p>
                    <a href="enquiry.html">Register for free</a>
                </div>
            </div>
            {/* <!-- END HELP BOX --> */}
        </div>
    </div>
    {/* <!-- END HEADER & MENU --> */}

    {/* <!-- HEADER & MENU --> */}
    <div className="hom-top">
        <div className="container">
            <div className="row">
                <div className="hom-nav">
                    {/* <!-- LOGO --> */}
                    <div className="logo">
                        <span className="menu desk-menu">
                            <i></i><i></i><i></i>
                        </span>
                        {/* <a href="index.html" className="logo-brand"><img src="images/logo-b.png" alt="" loading="lazy"
                                className="ic-logo"/></a> */}
                                                            
                                <span 
  className="logo-brand-only" 
  style={{ 
    fontWeight: "bold", 
    fontSize: "1.5rem", 
    color: "#d32f2f", 
    fontFamily: "Arial, sans-serif" 
  }}
>
     Ramjimatrimony
</span>
                    </div>

                    {/* <!-- TOP MENU --> */}
                    <div className="bl">
                        <ul>
                            <li className="smenu-pare">
                                <span className="smenu">Explore</span>
                                <div className="smenu-open smenu-box">
                                    <div className="container">
                                        <div className="row">
                                            <h4 className="tit">Explore category</h4>
                                            <ul>
                                                <li>
                                                    <div className="menu-box menu-box-2">
                                                        <h5>Browse profiles <span>1200+ Verified profiles</span></h5>
                                                        <span className="explor-cta">More details</span>
                                                        <a href="all-profiles.html" className="fclick"></a>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="menu-box menu-box-1">
                                                        <h5>Wedding page <span>Make reservation</span></h5>
                                                        <span className="explor-cta">More details</span>
                                                        <a href="wedding.html" className="fclick"></a>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="menu-box menu-box-3">
                                                        <h5>All Services<span>Lorem ipsum dummy</span></h5>
                                                        <span className="explor-cta">More details</span>
                                                        <a href="services.html" className="fclick"></a>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="menu-box menu-box-4">
                                                        <h5>Join Now <span>Lorem ipsum dummy</span></h5>
                                                        <span className="explor-cta">More details</span>
                                                        <a href="plans.html" className="fclick"></a>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="smenu-pare">
                                <span className="smenu">All pages</span>
                                <div className="smenu-open smenu-multi">
                                    <div className="container">
                                        <div className="row">
                                            <div className="multi-col">
                                                <div className="inn">
                                                    <h4>Page sets 1</h4>
                                                    <ul>
                                                        <li><a href="all-profiles.html">All profiles</a></li>
                                                        <li><a href="profile-details.html">Profile details</a></li>
                                                        <li><a href="wedding.html">Wedding</a></li>
                                                        <li><a href="wedding-video.html">Wedding video</a></li>
                                                        <li><a href="services.html">Our Services</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="multi-col">
                                                <div className="inn">
                                                    <h4>Page sets 2</h4>
                                                    <ul>
                                                        <li><a href="plans.html">Pricing plans</a></li>
                                                        <li><a href="login.html">Login</a></li>
                                                        <li><a href="sign-up.html">Sign-up</a></li>
                                                        <li><a href="photo-gallery.html">Photo gallery</a></li>
                                                        <li><a href="photo-gallery-1.html">Photo gallery 1</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="multi-col">
                                                <div className="inn">
                                                    <h4>Page sets 3</h4>
                                                    <ul>
                                                        <li><a href="contact.html">Contact</a></li>
                                                        <li><a href="about.html">About</a></li>
                                                        <li><a href="blog.html">Blog</a></li>
                                                        <li><a href="blog-detail.html">Blog detail</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="multi-col">
                                                <div className="inn">
                                                    <h4>Page sets 4</h4>
                                                    <ul>
                                                        <li><a href="enquiry.html">Ask your doubts</a></li>
                                                        <li><a href="make-reservation.html">Make Reservation</a></li>
                                                        <li><a href="faq.html">FAQ</a></li>
                                                        <li><a href="coming-soon.html" target="_blank">Coming soon</a>
                                                        </li>
                                                        <li><a href="404.html">404</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="multi-col full">
                                                <div className="inn">
                                                    <h4>User dashboard pages</h4>
                                        <ul>
                                            <li><a href="user-dashboard.html">Dashboard</a></li>
                                            <li><a href="user-profile.html">My profile</a></li>
                                            <li><a href="user-interests.html">Interests</a></li>
                                            <li><a href="user-chat.html">Chat lists</a></li>
                                            <li><a href="user-plan.html">My plan details</a></li>
                                            <li><a href="user-setting.html">Profile settings</a></li>
                                            <li><a href="user-profile-edit.html">Edit full profile</a></li>
                                            <li><a href="login.html">Sign in</a></li>
                                        </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="smenu-pare">
                                <span className="smenu">Top pages</span>
                                <div className="smenu-open smenu-single">
                                    <ul>
                                        <li><a href="all-profiles.html">All profiles</a></li>
                                        <li><a href="profile-details.html">Profile details</a></li>
                                        <li><a href="wedding.html">Wedding</a></li>
                                        <li><a href="blog.html">Blog</a></li>
                                        <li><a href="blog-detail.html">Blog detail</a></li>
                                        <li><a href="about.html">About</a></li>
                                        <li><a href="contact.html">Contact</a></li>
                                        <li><a href="photo-gallery.html">Photo gallery</a></li>
                                        <li><a href="photo-gallery-1.html">Photo gallery 1</a></li>
                                        <li><a href="login.html">Login</a></li>
                                        <li><a href="sign-up.html">Sign-up</a></li>
                                        <li><a href="plans.html">Pricing plans</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li><a href="plans.html">Plans</a></li>
                            {/* <li><a href="sign-up.html">Register</a></li> */}
                            <li className="smenu-pare">
                                {/* <span className="smenu">Dashboard</span> */}
                                <div className="smenu-open smenu-single">
                                    <ul>
                                        <li><a href="user-dashboard.html">Dashboard</a></li>
                                        <li><a href="user-profile.html">My profile</a></li>
                                        <li><a href="user-interests.html">Interests</a></li>
                                        <li><a href="user-chat.html">Chat lists</a></li>
                                        <li><a href="user-plan.html">My plan details</a></li>
                                        <li><a href="user-setting.html">Profile settings</a></li>
                                        <li><a href="user-profile-edit.html">Edit full profile</a></li>
                                        <li><a href="login.html">Sign in</a></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>

                    {/* <!-- USER PROFILE --> */}
                    <div className="al">
                        <div className="head-pro">
                            <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                            <b>Advisor</b><br/>
                            <h4>Ashley emyy</h4>
                            <span className="fclick"></span>
                        </div>
                    </div>

                    {/* <!--MOBILE MENU--> */}
                    <div className="mob-menu">
                        <div className="mob-me-ic">
                            <span className="ser-open mobile-ser">
                                <img src="images/icon/search.svg" alt=""/>
                            </span>
                            <span className="mobile-exprt" data-mob="dashbord">
                                <img src="images/icon/users.svg" alt=""/>
                            </span>
                            <span className="mobile-menu" data-mob="mobile">
                                <img src="images/icon/menu.svg" alt=""/>
                            </span>
                        </div>
                    </div>
                    {/* <!--END MOBILE MENU--> */}
                </div>
            </div>
        </div>
    </div>
    {/* <!-- END HEADER & MENU --> */}

    {/* <!-- MOBILE MENU POPUP --> */}
    <div className="mob-me-all mobile_menu">
        <div className="mob-me-clo"><img src="images/icon/close.svg" alt=""/></div>
        <div className="mv-bus">
            <h4><i className="fa fa-globe" aria-hidden="true"></i> EXPLORE CATEGORY</h4>
            <ul>
                <li><a href="all-profiles.html">Browse profiles</a></li>
                <li><a href="wedding.html">Wedding page</a></li>
                <li><a href="services.html">All Services</a></li>
                <li><a href="plans.html">Join Now</a></li>
            </ul>
            <h4><i className="fa fa-align-center" aria-hidden="true"></i> All Pages</h4>
            <ul>
                <li><a href="all-profiles.html">All profiles</a></li>
                <li><a href="profile-details.html">Profile details</a></li>
                <li><a href="wedding.html">Wedding</a></li>
                <li><a href="wedding-video.html">Wedding video</a></li>
                <li><a href="services.html">Our Services</a></li>
                <li><a href="plans.html">Pricing plans</a></li>
                <li><a href="login.html">Login</a></li>
                <li><a href="sign-up.html">Sign-up</a></li>
                <li><a href="photo-gallery.html">Photo gallery</a></li>
                <li><a href="photo-gallery-1.html">Photo gallery 1</a></li>
                <li><a href="contact.html">Contact</a></li>
                <li><a href="about.html">About</a></li>
                <li><a href="blog.html">Blog</a></li>
                <li><a href="blog-detail.html">Blog detail</a></li>
                <li><a href="enquiry.html">Ask your doubts</a></li>
                <li><a href="make-reservation.html">Make Reservation</a></li>
                <li><a href="faq.html">FAQ</a></li>
                <li><a href="coming-soon.html" target="_blank">Coming soon</a></li>
                <li><a href="404.html">404</a></li>
            </ul>
            <div className="menu-pop-help">
                <h4>Support Team</h4>
                <div className="user-pro">
                    <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                </div>
                <div className="user-bio">
                    <h5>Ashley emyy</h5>
                    <span>Senior personal advisor</span>
                    <a href="enquiry.html" className="btn btn-primary btn-sm">Ask your doubts</a>
                </div>
            </div>
            <div className="menu-pop-soci">
                <ul>
                    <li><a href="#!"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-instagram" aria-hidden="true"></i></a></li>
                </ul>
            </div>
            <div className="late-news">
                <h4>Latest news</h4>
                <ul>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/1.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/3.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/4.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                </ul>
            </div>
            <div className="prof-rhs-help">
                <div className="inn">
                    <h3>Tell us your Needs</h3>
                    <p>Tell us what kind of service you are looking for.</p>
                    <a href="enquiry.html">Register for free</a>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- END MOBILE MENU POPUP --> */}

    {/* <!-- MOBILE USER PROFILE MENU POPUP --> */}
    <div className="mob-me-all dashbord_menu">
        <div className="mob-me-clo"><img src="images/icon/close.svg" alt=""/></div>
        <div className="mv-bus">
            <div className="head-pro">
                <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                <b>user profile</b><br/>
                <h4>Ashley emyy</h4>
            </div>
            <ul>
                <li><a href="login.html">Login</a></li>
                <li><a href="sign-up.html">Sign-up</a></li>
                <li><a href="plans.html">Pricing plans</a></li>
                <li><a href="all-profiles.html">Browse profiles</a></li>
            </ul>
        </div>
    </div>
    {/* <!-- END USER PROFILE MENU POPUP --> */}

    {/* <!-- REGISTER --> */}

 
   
<div className="container" style={{ marginTop: "40px", marginBottom: "40px", padding: "20px" }}>
  <div className="row">
    {/* 🔹 Sidebar with Navigation */}
    <div className="col-md-3 col-lg-3">
      <div className="db-nav">
        <div className="db-nav-pro text-center">
          <img
            src={mainImage || "/images/default-profile.jpg"}
            alt="Profile"
            className="img-fluid rounded-circle border"
            style={{ maxWidth: "150px", height: "150px", objectFit: "cover" }}
          />
        </div>
         <div className="db-nav-list mt-3">
          <ul>
            <li>
              <a href="user-dashboard.html">
                <i className="fa fa-tachometer" aria-hidden="true"></i> Dashboard
              </a>
            </li>
            <li>
              <Link to="/profileinformation" className="act">
                <i className="fa fa-male" aria-hidden="true"></i> Profile
              </Link>
            </li>
            <li>
              <a href="user-interests.html">
                <i className="fa fa-handshake-o" aria-hidden="true"></i> Interests
              </a>
            </li>
            <li>
              <a href="user-chat.html">
                <i className="fa fa-commenting-o" aria-hidden="true"></i> Chat list
              </a>
            </li>
            <li>
              <a href="user-plan.html">
                <i className="fa fa-money" aria-hidden="true"></i> Plan
              </a>
            </li>
            <li style={{ marginTop: "10px" }}>
              <Link to="/settings" style={{ textDecoration: "none", color: "#333" }}>
                <i className="fa fa-cog" aria-hidden="true"></i> Setting
              </Link>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-sign-out" aria-hidden="true"></i> Log out
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    {/* 🔹 Main Profile Content */}
    <div className="col-md-9">
      <h2 className="mb-4 text-center">My Profile Information</h2>
      <div className="row">
        {/* Left Column: Profile Picture + Thumbnails */}
        {/* <div className="col-md-4 text-center mb-4"> */}
          {/* <img
            src={mainImage || "/images/default-profile.jpg"}
            alt="Profile"
            className="img-fluid rounded-circle border"
            style={{ maxWidth: "200px", height: "200px", objectFit: "cover" }}
          /> */}

          {/* Thumbnails */}
          {/* <div className="d-flex flex-wrap justify-content-center mt-3 gap-2"> */}
            {/* {(showAll ? allImages : allImages.slice(0, 3)).map((img, i) => ( */}
            {/* //   <div key={i} style={{ position: "relative" }}> */}
                {/* <img
                  src={img}
                  alt={`img-${i}`}
                  className="border"
                  style={{
                    width: "60px",
                    height: "60px",
                    objectFit: "cover",
                    cursor: "pointer",
                    border: mainImage === img ? "3px solid blue" : "1px solid #ddd",
                    borderRadius: "8px",
                  }}
                  onClick={() => handleSetMain(img)}
                /> */}
                {/* <button
                  onClick={() => handleRemove(i)}
                  style={{
                    position: "absolute",
                    top: "-5px",
                    right: "-5px",
                    background: "red",
                    color: "white",
                    border: "none",
                    borderRadius: "50%",
                    width: "18px",
                    height: "18px",
                    fontSize: "12px",
                    lineHeight: "18px",
                    cursor: "pointer",
                  }}
                >
                  ×
                </button> */}
              {/* </div> */}
            
          {/* </div> */}

          {/* View All toggle */}
          {/* {allImages.length > 3 && ( */}
            {/* // <button */}
            {/* //   className="btn btn-sm btn-outline-primary mt-2" */}
            {/* //   onClick={() => setShowAll(!showAll)} */}
            
            {/* //   {showAll ? "Hide" : "View All"} */}
            {/* // </button> */}
        
        {/* </div> */}

        {/* Right Side: 3 Columns */}
        {/* Right Side: 4 Columns */}
 <div className="col-md-12">
      <div className="row g-4">
        {/* Column 1 - My Profile (Read-only) */}
        <div className="col-md-3">
          <div className="accordion" id="accordionProfile">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingProfile">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseProfile"
                >
                  Bio
                </button>
              </h2>
              <div
                id="collapseProfile"
                className="accordion-collapse collapse"
              >
                <div className="accordion-body">
                  <p><b>Name:</b> {formData.name}</p>
                  <p><b>Phone:</b> {formData.mobile}</p>
                  <p><b>Gender:</b> {formData.gender}</p>
                  <p><b>DOB:</b> {formData.dob}</p>
                  <p><b>Age:</b> {formData.age}</p>
                  <p><b>Email:</b> {formData.email}</p>
                  <p><b>District:</b> {formData.district}</p>
                  <p><b>Taluk:</b> {formData.taluk}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

  {/* Column 2 - Job & Education */}
<div className="col-md-3">
  <div className="accordion" id="accordionJob">
    <div className="accordion-item">
      <h2 className="accordion-header" id="headingJob">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseJob"
        >
          Job & Education
        </button>
      </h2>
      <div
        id="collapseJob"
        className="accordion-collapse collapse"
      >
        <div className="accordion-body">
          <p><b>Job Type:</b> {formData.jobType}</p>

          {/* ✅ Monthly Income same style as Job Type */}
       <p>
  <b>Monthly Income:</b>{" "}
 <input
  type="text"
  name="monthlyIncome"
  value={formData.monthlyIncome || ""}
  onChange={handleChange}
  className="form-control form-control-sm d-inline-block"
  style={{ width: "150px", marginLeft: "1px" }}
/>

</p>


          <p><b>Qualification:</b> {formData.qualification}</p>
          <p><b>Caste:</b> {formData.caste}</p>
        </div>
      </div>
    </div>
  </div>
</div>


        {/* Column 3 - Address (Read-only) */}
        <div className="col-md-3">
          <div className="accordion" id="accordionAddress">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingAddress">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseAddress"
                >
                  Caste & religion
                </button>
              </h2>
              <div
                id="collapseAddress"
                className="accordion-collapse collapse"
              >
                <div className="accordion-body">
                   <label>Caste</label>
                    <input
                      type="text"
                      name="motherName"
                      value={formData.motherName}
                      onChange={handleChange}
                      className="form-control"
                    />
                </div>
                 <div className="accordion-body">
                    <label>Religion</label>
                    <input
                      type="text"
                      name="brotherName"
                      value={formData.religion}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
              </div>
            </div>
          </div>
        </div>

        {/* Column 4 - Family Details (Editable) */}
        <div className="col-md-3">
          <div className="accordion" id="accordionFamily">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFamily">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFamily"
                >
                  Family Details
                </button>
              </h2>
              <div
                id="collapseFamily"
                className="accordion-collapse collapse"
              >
                <div className="accordion-body">
                  <div className="mb-2">
                    <label>Father's Name</label>
                    <input
                      type="text"
                      name="fatherName"
                      value={formData.fatherName}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                  <div className="mb-2">
                    <label>Mother's Name</label>
                    <input
                      type="text"
                      name="motherName"
                      value={formData.motherName}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                  <div className="mb-2">
                    <label>Brother's Name</label>
                    <input
                      type="text"
                      name="brotherName"
                      value={formData.brotherName}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                  <div className="mb-2">
                    <label>Sister's Name</label>
                    <input
                      type="text"
                      name="sisterName"
                      value={formData.sisterName}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Column 5 - Hobbies (Editable) */}
        <div className="col-md-3">
          <div className="accordion" id="accordionHobbies">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingHobbies">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseHobbies"
                >
                  Hobbies
                </button>
              </h2>
              <div
                id="collapseHobbies"
                className="accordion-collapse collapse"
              >
                <div className="accordion-body">
                  <textarea
                    name="hobbies"
                    value={formData.hobbies}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter hobbies"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="text-center mt-4">
         <button className="btn btn-primary" onClick={handleSave}>
          Save Details
        </button>
      </div>
    </div>


      </div>
    </div>
  </div>
</div>




    {/* <!-- END --> */}

    {/* <!-- FOOTER --> */}
    <section className="wed-hom-footer">
        <div className="container">
            <div className="row foot-supp">
                <h2><span>Free support:</span> +92 (8800) 68 - 8960 &nbsp;&nbsp;|&nbsp;&nbsp; <span>Email:</span>
                    info@example.com</h2>
            </div>
            <div className="row wed-foot-link wed-foot-link-1">
                <div className="col-md-4">
                    <h4>Get In Touch</h4>
                    <p>Address: 3812 Lena Lane City Jackson Mississippi</p>
                    <p>Phone: <a href="tel:+917904462944">+92 (8800) 68 - 8960</a></p>
                    <p>Email: <a href="mailto:info@example.com">info@example.com</a></p>
                </div>
                <div className="col-md-4">
                    <h4>HELP &amp; SUPPORT</h4>
                    <ul>
                        <li><a href="about-us.html">About company</a>
                        </li>
                        <li><a href="#!">Contact us</a>
                        </li>
                        <li><a href="#!">Feedback</a>
                        </li>
                        <li><a href="about-us.html#faq">FAQs</a>
                        </li>
                        <li><a href="about-us.html#testimonials">Testimonials</a>
                        </li>
                    </ul>
                </div>
                <div className="col-md-4 fot-soc">
                    <h4>SOCIAL MEDIA</h4>
                    <ul>
                        <li><a href="#!"><img src="images/social/1.png" alt=""/></a></li>
                        <li><a href="#!"><img src="images/social/2.png" alt=""/></a></li>
                        <li><a href="#!"><img src="images/social/3.png" alt=""/></a></li>
                        <li><a href="#!"><img src="images/social/5.png" alt=""/></a></li>
                    </ul>
                </div>
            </div>
            <div className="row foot-count">
                <p>Company name Site - Trusted by over thousands of Boys & Girls for successfull marriage. <a
                        href="sign-up.html" className="btn btn-primary btn-sm">Join us today !</a></p>
            </div>
        </div>
    </section>
    {/* <!-- END --> */}
    {/* <!-- COPYRIGHTS --> */}
    <section>
        <div className="cr">
            <div className="container">
                <div className="row">
                    <p>Copyright © <span id="cry">2017-2020</span> <a href="#!" target="_blank">Company.com</a> All
                        rights reserved.</p>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}
;

